import { HOURS_PER_DAY, MS_PER_HOUR } from '@shared/core';
import { Location as RestaurantLocation } from '@shared/location/models';

const FUTURE_DAYS_AHEAD = 30;
const DEFAULT_HOURS_AHEAD = 12;

type WaitlistWindowOptions = Pick<RestaurantLocation, 'bookingOptions' | 'displayOptions'>;

// "Waitlist: hours of upcoming reservations to show" (Settings / Reservation options)
export function getReservationWaitlistHoursAhead(restaurantLocation: WaitlistWindowOptions): number {
  return restaurantLocation.bookingOptions?.partiesLimiter ??
    (restaurantLocation.displayOptions.future
      ? FUTURE_DAYS_AHEAD * HOURS_PER_DAY
      : DEFAULT_HOURS_AHEAD);
}

// Upper bound only: the lower (auto-remove) bound is shared with walk-ins.
export function isInReservationWaitlistWindow(
  quotedTime: number,
  hoursAhead: number,
  now: number,
): boolean {
  return quotedTime < now + (hoursAhead * MS_PER_HOUR);
}
